import { Link } from 'react-router-dom';
import type { TvSeries } from '@/types';
import Tag from './Tag';

interface TvCardProps {
  series: TvSeries;
  favorite?: boolean;
  onToggleFavorite?: (id: string) => void;
}

export default function TvCard({ series, favorite, onToggleFavorite }: TvCardProps) {
  return (
    <article className="group flex flex-col bg-background-50 border border-background-200 rounded-lg overflow-hidden hover:border-primary-300 transition-colors">
      <Link to={`/detail/tv/${series.id}`} className="relative block aspect-[2/3] overflow-hidden cursor-pointer">
        <img
          src={series.poster}
          alt={`《${series.title}》剧集海报`}
          title={`${series.title} 电视剧 海报`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute top-2 left-2 flex flex-col gap-1">
          <span className="px-2 py-0.5 rounded-md bg-foreground-950/70 text-background-50 text-xs font-label backdrop-blur-sm">
            {series.year}
          </span>
        </div>
        <span className="absolute bottom-2 right-2 px-2 py-0.5 rounded-md bg-accent-500 text-background-50 dark:text-foreground-950 text-xs font-label font-bold">
          {series.rating.toFixed(1)} 分
        </span>
        {onToggleFavorite ? (
          <button
            type="button"
            aria-label={favorite ? '取消收藏' : '收藏'}
            onClick={(event) => {
              event.preventDefault();
              event.stopPropagation();
              onToggleFavorite(series.id);
            }}
            className="absolute top-2 right-2 w-8 h-8 rounded-full bg-foreground-950/50 text-background-50 flex items-center justify-center backdrop-blur-sm hover:bg-accent-500 transition-colors cursor-pointer"
          >
            <i className={favorite ? 'ri-heart-3-fill text-accent-300' : 'ri-heart-3-line'}></i>
          </button>
        ) : null}
      </Link>
      <div className="flex flex-col flex-1 p-3 md:p-4">
        <Link to={`/detail/tv/${series.id}`} className="cursor-pointer">
          <h3 className="font-heading text-base font-bold text-foreground-950 line-clamp-1 group-hover:text-primary-600 transition-colors">
            {series.title}
          </h3>
        </Link>
        <div className="flex flex-wrap gap-1.5 mt-2">
          {series.tags.slice(0, 3).map((tag) => (
            <Tag key={tag} label={tag} variant="secondary" />
          ))}
        </div>
        <p className="mt-2 text-xs text-foreground-500 line-clamp-1">主演：{series.cast.join(' / ')}</p>
        <p className="mt-2 text-sm text-foreground-600 line-clamp-2 leading-relaxed flex-1">{series.synopsis}</p>
      </div>
    </article>
  );
}